import React from 'react';
import PropTypes from 'prop-types';

import { Badge } from '@openedx/paragon';

/**
 * Small presentational badge showing a course's access type (e.g. 'free', 'paid', 'demo').
 */
export const AccessTypeBadge = ({ accessType }) => {
  if (!accessType) {
    return null;
  }
  return (
    <Badge variant="light" className="access-type-badge">
      {accessType}
    </Badge>
  );
};

AccessTypeBadge.propTypes = {
  accessType: PropTypes.string,
};

AccessTypeBadge.defaultProps = {
  accessType: null,
};

export default AccessTypeBadge;
